let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("6lKgX")), load("4dXiA")]).then(() => parcelRequire('2IyKF'));